import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import {Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import {config} from "../../../utility/swaggerClient";
import { Control, LocalForm, Errors } from 'react-redux-form';

const ModalExample = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    stagingprj,
    store
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("Select source code staging project names:");
  const [warningText, setWarningText] = useState("Exception");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMesssage] = useState("");


  const toggle = () => setModal(!modal);

  const close = ()=>{
    let body ={};
    if(true){
        body=JSON.stringify({
              firstNameAndLastName : name,
              companyName: company,
              corporateEmail: email,
              message
            })
    }else{
      body=JSON.stringify({
        firstNameAndLastName : store.getState().shift.auth.firstname + store.getState().shift.auth.lastname,
        companyName: store.getState().shift.auth.customerid,
        corporateEmail: store.getState().shift.auth.email,
        message
      })
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
      body
    };
    fetch(`${config.protocol}://${config.host}/api/user/contactus`, requestOptions)
      .then(data => {
        toggle();
      });
  }

  console.log("3333")
  useEffect(() => {

  }, []);

  return (

    <a>
      <div style={{cursor: 'pointer', display: 'inline-block',}}
    //   backgroundColor:"#5e7a2b", marginBottom:'5px',height:'42px',width:'120px', 
    //   fontsize: '14px',
    // borderradius: '4px',
    // bordestyle: 'solid',
    // borderwidth: '1px',
    // borderradius: '4px',
    // backgroundcolor: '#5e7a2b',}}
       onClick={toggle}> {buttonLabel}</div>
      {/* <Button className="button asse_upload" style={{backgroundColor:"#5e7a2b", marginBottom:'5px',height:'42px',width:'120px'}} onClick={toggle}>{buttonLabel}</Button> */}
      <Modal isOpen={modal} toggle={toggle} className={className} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            <div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/>
            <i>Add an Existing User </i>
            </div>
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>{warningText} </div>)}
          </ModalHeader>
        )}
        <ModalBody style={{overflow:'auto'}}>
        <LocalForm
                    className="form"
                    onSubmit={() =>
                      props.clickSubmitHandler(
                        props.username
                        // props.repo,
                        // srclang,
                        // targetLanguage,
                        // description,
                        // jobType,
                        // stagingrepo,
                        // customer,
                                           
                      )
                    }
                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="pick.use"
                            defaultMessage="Pick a User"
                          />
                        </label>

                        <Control.select
                          model=".name"
                          autoFocus
                          required
                          value={name}
                         // onChange={selectCus}
                        //  onChange = {(e)=>{setMesssage(e.target.value)}}
                        >
                          {/* {(customer === "" || customer === null) && <option value="">Please select JDBC Driver</option>}
                          {customersList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))} */}

                     <option value="">Please select a user</option>
                        </Control.select>
                      </fieldset>
                      </div>
      </LocalForm>
          {/* <Form>
            {true && (
              <div>
                <FormGroup>
                  <Input placeholder="First and Last Name" value={name} onChange={(e)=>{setName(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                <Input placeholder="Company Name" value={company} onChange={(e)=>{setCompany(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                <Input type="email" placeholder="Corporate Email" value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                </FormGroup>
              </div>
            )}


            <FormGroup>
              <Input type="textarea"  placeholder="Message" style={{height: '200px'}}
                     value={message}
                     onChange = {(e)=>{setMesssage(e.target.value)}}
              />
            </FormGroup>
          </Form> */}
        </ModalBody>
        <ModalFooter>
          {(info || warning) &&(
            <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={close}
            >
              <FormattedMessage id="nav.ok" defaultMessage="OK" />
            </button>
          )}
        </ModalFooter>
      </Modal>
    </a>
  );
}

export default ModalExample;



// WEBPACK FOOTER //
// ./src/components/views/ManagementDDLjdbc2/popfooter.js